import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { CampaignForm } from "@/components/hiring/campaign-form";
import { Button } from "@/components/ui/button";

export default function NewCampaign() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="sm" asChild className="text-muted-foreground">
          <Link to="/hiring">
            <ChevronLeft className="h-4 w-4 mr-1" />
            Back
          </Link>
        </Button>
      </div>
      <div>
        <h1 className="text-xl sm:text-2xl font-bold tracking-tight">New Campaign</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Set up a hiring campaign to recruit TikTok creators.
        </p>
      </div>
      <CampaignForm />
    </div>
  );
}
